import m from "../../geodata/es2015/tunisiaHigh";
window.am4geodata_tunisiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/tunisiaHigh.js
// module id = null
// module chunks = 